module.exports = __webpack_public_path__ + "img/Violon.674b013a.png";